import * as React from "react"
import { connect } from "react-redux"
import trans from "trans"

import { Button, Theme, Icon } from "@bdfx/mergado-ui-kit"

import { PreviewsForm } from 'template-previews/types'
import {projectId, eshopId} from "app/helpers/api"
import { updateInputValue as change } from "app/reducers/form"
import {RandomProduct} from "shape-edit/types";
import {RouterType, withRouter} from "app/components/routes";
import { selectFormValues } from "app/reducers/form"

interface Props {
    router: RouterType
    change: typeof change
    previewsForm: PreviewsForm
    updatePreviews: Function
    randomProduct: RandomProduct
}

interface State {
    randomNumber: number
}

class Buttons extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props)

        this.state = {
            randomNumber: new Date().getTime()
        }
    }

    renderEditButton() {
        const { previewsForm } = this.props
        return (
            <Button
                type={'void'}
                onClick={() => this.props.router.navigate(`/eshop/${eshopId}/project/${projectId}/templates/${previewsForm.view.id}/edit`)}
                label={trans("edit_template")}
                size="small"
            />
        )
    }

    refreshImages = () => {
        this.setState({randomNumber: new Date().getTime()})
        this.props.change('previewsForm', 'view.randomNumber', this.state.randomNumber)
        this.props.updatePreviews({
            ...this.props.previewsForm,
            randomNumber: this.state.randomNumber
        })
    }

    renderRefreshButton() {
        const {randomProduct} = this.props
        return <Button
            onClick={() => this.refreshImages()}
            type={'void'}
            color={Theme.green}
            icon={randomProduct && randomProduct.isLoading ? <Icon type={'spinner'} /> : undefined}                
            size="small"
        >{trans("random_product")}</Button>
    }

    render() {
        const { previewsForm } = this.props
        return previewsForm && previewsForm.view && previewsForm.view.type === "template" ? this.renderEditButton() : this.renderRefreshButton()
    }
}

function mapStateToProps(state) {
    return {
        previewsForm: selectFormValues(state, 'previewsForm'),
        randomProduct: state.randomProduct,
    }
}

export default connect(mapStateToProps, {
    change,
})(withRouter(Buttons))